// components/Events/CrowdControlEvent.tsx

import React, { useContext } from 'react';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { GameLog } from '../../../../Logs/LogsDisplay';
import './CrowdControlEvent.css'; // Import CSS if needed

interface BaseRendererProps {
  log: GameLog;
}

const CrowdControlEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets } = useContext(GameAssetsContext);
  const { ccIcons } = gameWideAssets;

  const details = log.details;
  const ccType = details.ccType;
  const duration = details.duration;
  const strength = details.strength;
  const sourceName = details.source;
  const sourceChampionName = details.sourceChampionName;
  const targetChampionName = details.targetChampionName;

  // Get the CC icon
  const ccIcon = ccIcons[ccType];

  return (
    <div className="cc-event">
      <div className="cc-icon-wrapper">
        {ccIcon ? (
          <img src={ccIcon} alt={ccType} className="cc-icon" />
        ) : (
          <div className="cc-icon-placeholder">{ccType}</div>
        )}
      </div>
      <div className="cc-details">
        <span className="cc-type">{ccType}</span>
        <span className="cc-duration">{duration.toFixed(2)}s</span>
        {strength !== undefined && <span className="cc-strength">-{strength}%</span>}
      </div>
    </div>
  );
};

export default CrowdControlEvent;
